import { parse, parseISO } from 'date-fns';

/**
 * Parses a date-only string from various formats:
 * - ISO 8601 (with or without Z suffix)
 * - DD/MM/YYYY (en-GB locale)
 *
 * Returns null if the value cannot be parsed.
 */
export function parseDateFlexible(value: any): Date | null {
    if (!value) return null;
    try {
        const str = typeof value === 'string' ? value : String(value);
        if (str.endsWith('Z')) {
            const d = new Date(str);
            return isNaN(d.getTime()) ? null : d;
        }
        // DD/MM/YYYY — en-GB locale convention used throughout the application
        if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(str)) {
            const d = parse(str, 'dd/MM/yyyy', new Date());
            return isNaN(d.getTime()) ? null : d;
        }
        const d = parseISO(str);
        return isNaN(d.getTime()) ? null : d;
    } catch {
        return null;
    }
}

/**
 * Parses a date-time string from various formats:
 * - ISO 8601 (with or without Z suffix)
 * - DD/MM/YYYY followed by time in 12h or 24h format
 * - DD/MM/YYYY (date-only, time defaults to midnight)
 *
 * Returns null if the value cannot be parsed.
 */
export function parseDateTimeFlexible(value: any): Date | null {
    if (!value) return null;
    try {
        const str = typeof value === 'string' ? value : String(value);
        if (str.endsWith('Z')) {
            const d = new Date(str);
            return isNaN(d.getTime()) ? null : d;
        }
        if (/^\d{1,2}\/\d{1,2}\/\d{4}/.test(str)) {
            const formats = [
                'dd/MM/yyyy h:mma',
                'dd/MM/yyyy h:mm a',
                'dd/MM/yyyy hh:mm a',
                'dd/MM/yyyy HH:mm',
                'dd/MM/yyyy',
            ];
            for (const fmt of formats) {
                const d = parse(str, fmt, new Date());
                if (!isNaN(d.getTime())) return d;
            }
        }
        const d = parseISO(str);
        return isNaN(d.getTime()) ? null : d;
    } catch {
        return null;
    }
}
